import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import setAgeRangeHandler from "./set-age-range.handler";
import setGenderHandler from "./set-gender.handler";
import getProfileHandler, { IProfile } from "./get-profile.handler";
import setProfileHandler from "./set-profile.handler";

export enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2
}

export enum AgeRange {
    Unknown = 0,
    UpTo18 = 1,
    From18To30 = 2,
    From30To50 = 3,
    From50 = 4,
}

export interface IProfileState extends IRequestState {
    gender: Gender;
    ageRange: AgeRange;

    inited: boolean;
};

const initialState: IProfileState = {
    gender: Gender.Unknown,
    ageRange: AgeRange.Unknown,

    inited: false,

    loading: false,
    error: "",
};

const profileSlice = createSlice({
    name: 'profileSlice',
    initialState,
    reducers: {
        updateProfile: (state, action: PayloadAction<IProfile>) => {
            state.gender = action.payload.gender;
            state.ageRange = action.payload.ageRange;
            state.inited = true;
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IProfileState>) => {
        getProfileHandler(builder);
        setProfileHandler(builder);
        setGenderHandler(builder);
        setAgeRangeHandler(builder);
    },
});

export default profileSlice.reducer;
export const { updateProfile } = profileSlice.actions;